import {Grid2, Typography} from "@mui/material";
import * as React from "react";
import {TestimonyCard} from "@/pages/landing-page/utils/TestimonyCard";
import {Section1aDTO} from "@/pages/landing-page/landing-page-data";
import {color_blue, color_green} from "@/agentur/AgenturColors";
import {LANDING_HEADLINE} from "@/pages/landing-page/utils/landing-font-sizes";
import {COLORED_SECTION_PX, COMPACT_SECTION_MIN_HEIGHT} from "@/pages/landing-page/utils/landing-section-layout";

interface Section1aProps {
    data: Section1aDTO;
}

export const Section1a = ({ data }: Section1aProps) => (
    <Grid2
        container
        direction="column"
        paddingTop={4}
        width="100%"
        sx={{
            minHeight: COMPACT_SECTION_MIN_HEIGHT,
            position: "relative",
            backgroundColor: color_blue[3],
            px: COLORED_SECTION_PX
        }}
    >
        <Grid2 width="100%">
            <Typography
                sx={{ fontSize: LANDING_HEADLINE }}
                fontWeight="700"
                paddingBottom={2}
                maxWidth="fit-content"
                borderBottom={`3px solid ${color_green[2]}`}
            >
                {data?.title}
            </Typography>
        </Grid2>
        <Grid2 sx={{ paddingTop: { xs: 2, md: 4, lg: 12 } }}>
            <TestimonyCard
                text={data.testimony.text}
                image={data.testimony.image}
                name={data.testimony.name}
                width="100%"
                height="100%"
                active
                noBorder
            />
        </Grid2>
    </Grid2>
);
